import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, signOut } from "./auth/AuthContext.jsx";
import Login from "./auth/Login.jsx";
import AuthCallback from "./auth/AuthCallback.jsx";
import MileMarker from "./MileMarker.jsx";
import DemoShell from "./demo/DemoShell.jsx";
import { C } from "./theme/tokens.js";

function Inactive() {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center",
      background: C.shell, padding: 20, fontFamily: "system-ui, sans-serif" }}>
      <div style={{ background: C.panel, padding: 32, borderRadius: 18, maxWidth: 420, width: "100%",
        border: `1px solid ${C.line}`, textAlign: "center" }}>
        <div style={{ fontSize: 11, letterSpacing: ".22em", color: C.red, fontWeight: 700 }}>
          MILE MARKER
        </div>
        <h1 style={{ fontSize: 22, margin: "8px 0 12px", color: C.text }}>Account inactive</h1>
        <p style={{ color: C.sub, fontSize: 14, lineHeight: 1.5 }}>
          Your account has been suspended. Reach out to your admin if you believe this is in error.
        </p>
        <button onClick={() => signOut().then(() => window.location.assign("/login"))}
          style={{ marginTop: 22, padding: "10px 18px", borderRadius: 9,
            background: C.ink, color: "#fff", border: "none", fontWeight: 600,
            fontSize: 13, cursor: "pointer" }}>
          Sign out
        </button>
      </div>
    </div>
  );
}

function Gate({ children }) {
  const { session, profile, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center",
        background: C.shell, color: C.sub, fontFamily: "system-ui, sans-serif" }}>
        Loading…
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  if (profile?.deleted_at) return <Inactive />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/demo/team/:personId" element={<DemoShell initialView="team" />} />
        <Route path="/demo/team" element={<DemoShell initialView="team" />} />
        <Route path="/demo/help" element={<DemoShell initialView="help" />} />
        <Route path="/demo/manage/invite" element={<DemoShell initialView="bulk" />} />
        <Route path="/demo/manage" element={<DemoShell initialView="manage" />} />
        <Route path="/demo" element={<DemoShell />} />
        <Route path="/team/:personId" element={<Gate><MileMarker initialView="team" /></Gate>} />
        <Route path="/team" element={<Gate><MileMarker initialView="team" /></Gate>} />
        <Route path="/manage/invite" element={<Gate><MileMarker initialView="bulk" /></Gate>} />
        <Route path="/manage" element={<Gate><MileMarker initialView="manage" /></Gate>} />
        <Route path="/help" element={<Gate><MileMarker initialView="help" /></Gate>} />
        <Route path="/" element={<Gate><MileMarker /></Gate>} />
      </Routes>
    </AuthProvider>
  );
}
